import { useContext, useState } from "react";
import { toast } from "sonner";
import axios from "../axios";
import { RmcContext } from "../../components/context/RmcContext";

export const useBrandLive = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isJoining, setIsJoining] = useState(false);
  const [liveData, setliveData] = useState([]);
  const [joinedData, setJoinedData] = useState({});
  const [liveHistory, setLiveHistory] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const { worldBranch } = useContext(RmcContext);
  const handleGetBrandLive = async (brandId) => {
    try {
      setIsLoading(true);
      const res = await axios.get(
        `/audiences/brand/${brandId}/live${
          worldBranch?.value ? `?branch_id=${worldBranch.value}` : ""
        }`
      );

      if (res.status === 200) {
        setIsLoading(false);
        setliveData(res?.data?.data);
      }
    } catch (err) {
      setIsLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };

  const handleJoinBrandLive = async (brandId, LiveId) => {
    try {
      setIsJoining(true);
      const res = await axios.post(
        `/audiences/join-live`,
        JSON.stringify({
          brand_id: brandId,
          live_id: LiveId,
          coined_earned: liveData?.live?.checkIn_amount,
        })
      );

      if (res.status === 201) {
        setJoinedData(res?.data?.data);
        setIsJoining(false);
        setIsOpen(true);
      }
    } catch (err) {
      setIsJoining(false);
      toast.error(err?.response?.data?.data?.error || "Failed to join live");
    }
  };

  const getLiveHistory = async (brandId) => {
    try {
      setIsLoading(true);
      const res = await axios.get(`/audiences/brand/${brandId}/live-history`);

      if (res.status === 200) {
        setIsLoading(false);
        setLiveHistory(res?.data?.data?.live_history);
      }
    } catch (err) {
      setIsLoading(false);
      toast.error(err?.response?.data?.message);
    }
  };
  return {
    handleGetBrandLive,
    handleJoinBrandLive,
    isLoading,
    isJoining,
    joinedData,
    liveData,
    isOpen,
    setIsOpen,
    getLiveHistory,
    liveHistory,
  };
};
